@if (confirmService.state(); as s) {
  <div class="confirm-backdrop" (click)="confirmService.respond(false)">
    <div class="confirm-modal" (click)="$event.stopPropagation()">

      <div class="confirm-icon" [class.confirm-icon--danger]="s.danger">
        <i [class]="s.danger ? 'fa fa-triangle-exclamation' : 'fa fa-circle-question'"></i>
      </div>

      <h3 class="confirm-title">{{ s.title }}</h3>
      <p class="confirm-message">{{ s.message }}</p>

      <div class="confirm-actions">
        <sof-button customClass="sof-button-secondary" type="button" (clicked)="confirmService.respond(false)">
          Cancelar
        </sof-button>
        <sof-button
          [customClass]="s.danger ? 'sof-button-danger' : 'sof-button-primary'"
          type="button"
          (clicked)="confirmService.respond(true)"
        >
          {{ s.confirmLabel }}
        </sof-button>
      </div>

    </div>
  </div>
}
